import React from 'react';

type Props = {
  title: string;
};
const ContentTitle: React.FC<Props> = ({ title }) => {
  return (
    <div className="flex justify-center items-center rounded-md w-full h-8 bg-muted">
      <p className="text-xs font-bold">{title}</p>
    </div>
  );
};

export default ContentTitle;
